import { render, staticRenderFns } from "./DocsStatusBar.vue?vue&type=template&id=965da5b4&scoped=true"
import script from "./DocsStatusBar.vue?vue&type=script&lang=js"
export * from "./DocsStatusBar.vue?vue&type=script&lang=js"
import style0 from "./DocsStatusBar.vue?vue&type=style&index=0&id=965da5b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965da5b4",
  null
  
)

export default component.exports